import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect,  useContext , useRef} from "react";
import { CurrencyContext } from "./CurrencyContext";

const CurrencySelector = () => {


  const selectRef = useRef(null);

  const handleIconClick = () => {
    if (selectRef.current) {
      selectRef.current.focus();
      // On most browsers, focusing is enough to open the dropdown.
      // Unfortunately, there's no standard way to *programmatically open* the native select dropdown.
      // But focusing is still a user-friendly workaround.
    }
  };
  // const [selectedCurrency, setSelectedCurrency] = useState("1227501"); // Default to SGD

   const { selectedCurrency, setSelectedCurrency } = useContext(CurrencyContext);
  
     // Function to update currency
     const handleCurrencyChange = (event) => {
     const newCurrency = event.target.value;
     setSelectedCurrency(newCurrency);
     localStorage.setItem("selectedCurrency", newCurrency);

    // Update OVExplore preferences
    if (window.OVExplore10) {
      window.OVExplore10.preferences.siteItemId = newCurrency;
      if (typeof window.initializeOdySearchForm === "function") {
        window.initializeOdySearchForm(window.OVExplore10);
        console.log("Search form reinitialized with new currency.");
      }
    }

  };

  useEffect(() => {

    const savedCurrency = localStorage.getItem("selectedCurrency");

    if (savedCurrency) {
      setSelectedCurrency(savedCurrency);

    //   // ✅ Update OVExplore preferences and search form
    if (window.OVExplore10) {
      window.OVExplore10.preferences.siteItemId = savedCurrency;

      if (typeof window.initializeOdySearchForm === "function") {
        window.initializeOdySearchForm(window.OVExplore10);
        console.log("Search form reinitialized with saved currency.");
      }

    }
      
    } else {
      fetch("https://api.ipgeolocation.io/ipgeo?apiKey=c1812ee74c1d4638a243bb0fa91236ce")
        .then((response) => response.json())
        .then((data) => {
          const userCountry = data.country_code2;
          const countryCurrency = {
            US: "1228312",
            SG: "1227501",
            IN: "1237318",
          };

          if (countryCurrency[userCountry]) {
            setSelectedCurrency(countryCurrency[userCountry]);
            localStorage.setItem("selectedCurrency", countryCurrency[userCountry]);
          }
          
          // ✅ Also update preferences and search form

        if (window.OVExplore10) {
          window.OVExplore10.preferences.siteItemId = countryCurrency[userCountry];
           if (typeof window.initializeOdySearchForm === "function") {
            window.initializeOdySearchForm(window.OVExplore10);
            console.log("Search form reinitialized with geo-based currency.");
          }
        }

        })
        .catch((error) => console.error("Geo API error:", error));
    }
  }, []);

  return (
    <div
      className="currency-selector"
      style={{
        textAlign: "center",
        position: "relative",
        display: "flex",
        flexDirection: "row",
        gap: "1px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <select
        id="drpCurrency"
        value={selectedCurrency}
        onChange={handleCurrencyChange}
        style={{
          padding: "8px 15px",
          borderRadius: "20px",
          border: "0px solid #164D55",
          fontSize: "18px",
          fontWeight: "600",
          color: "#164D55",
          backgroundColor: "transparent",
          // outline: "none",
          cursor: "pointer",
          // appearance: "none",
          width: "100px",
        }}
      >
        <option value="1227501">SGD</option>
        <option value="1228312">USD</option>
        <option value="1237318">INR</option>
      </select>
      <FontAwesomeIcon icon={faCaretDown} style={{color:'#0a686b', position:'absolute', marginLeft:'4vh',cursor:'pointer', transform:'translateY(-10%)'}}  onClick={handleIconClick}/>
    
    </div>
    
  );
};

export default CurrencySelector;
